import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useStore } from '@hub/helpers/use-store';
import { Card, Statistic } from '@monorepo/react-components';

interface Props {
  programId: string;
  title: string;
  equity: number;
  baseBalance: number;
}

const AccountStopout: FunctionComponent<Props> = ({
  title,
  programId,
  equity,
  baseBalance,
}) => {
  const {
    dataStore: { programStore },
  } = useStore();
  const { t } = useTranslation(['dashboardTemplates']);

  const program = programStore.get(programId);
  const maxLoss = program?.config?.maxLoss || 0;
  const stopoutLevel = baseBalance - maxLoss;

  return (
    <Card
      title={title}
      extra={
        <Tooltip
          title={t(
            'dashboardTemplates:equity_level_account_will_be_terminated.',
          )}
        >
          <InfoCircleOutlined />
        </Tooltip>
      }
    >
      <Descriptions column={1}>
        <Descriptions.Item label={t('dashboardTemplates:current_level')}>
          <Statistic prefix={'$'} value={equity} precision={2} />
        </Descriptions.Item>
        <Descriptions.Item label={t('dashboardTemplates:stop_out')}>
          <Statistic prefix={'$'} value={stopoutLevel} precision={2} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default AccountStopout;
